"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-int"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash.throttle"));

var _uuid = require("uuid");

var constants = _interopRequireWildcard(require("@paprika/constants/lib/Constants"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _helpers = require("@paprika/stylers/lib/helpers");

var types = _interopRequireWildcard(require("./types"));

var _isInsideBoundaries = _interopRequireDefault(require("./helpers/isInsideBoundaries"));

var _getPosition = require("./helpers/getPosition");

var _getBoundingClientRect = _interopRequireDefault(require("./helpers/getBoundingClientRect"));

var _PopoverContext = _interopRequireWildcard(require("./PopoverContext"));

var _Content = _interopRequireDefault(require("./components/Content/Content"));

var _Card = _interopRequireDefault(require("./components/Card/Card"));

var _Trigger = _interopRequireDefault(require("./components/Trigger/Trigger"));

var _Tip = _interopRequireDefault(require("./components/Tip/Tip"));

var sc = _interopRequireWildcard(require("./Popover.styles"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var openDelay = 350;
var closeDelay = 150;
var throttleDelay = 20;
var focusableElementSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), [role="button"]'; // TODO: To handle cases where there are multiple scrolling containers, we need to implement
//       getScrollContainer as oneOfType([func, arrayOf(func)])

var Popover = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Popover, _React$Component);

  var _super = _createSuper(Popover);

  function Popover(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Popover);
    _this = _super.call(this, props);
    _this.getContextValues = (0, _memoizeOne["default"])(function (content, maxWidth, minWidth, width, isEager, isOpen, isPortal, portalElement, refContent, refTip, shouldKeepFocus, tip, zIndex, ariaIdForContent) {
      return {
        content: _objectSpread(_objectSpread({}, content), {}, {
          maxWidth: maxWidth,
          minWidth: minWidth,
          width: width,
          zIndex: zIndex,
          ariaId: ariaIdForContent
        }),
        isEager: isEager,
        isOpen: isOpen,
        onClick: _this.handleClick,
        onClose: _this.handleClose,
        onDelayedClose: _this.handleDelayedClose,
        onDelayedOpen: _this.handleDelayedOpen,
        onOpen: _this.handleOpen,
        isPortal: isPortal,
        portalElement: portalElement,
        refContent: refContent,
        refTip: refTip,
        shouldKeepFocus: shouldKeepFocus,
        tip: tip
      };
    });

    _this.getCoordinates = function () {
      var _this$props = _this.props,
          align = _this$props.align,
          edge = _this$props.edge,
          getScrollContainer = _this$props.getScrollContainer;
      var targetRect = _this.props.getPositioningElement === null ? (0, _getBoundingClientRect["default"])(_this.$popover.current) : (0, _getBoundingClientRect["default"])(_this.props.getPositioningElement());
      var contentCoords = (0, _getPosition.getContentCoordinates)({
        rect: _this.$content ? (0, _getBoundingClientRect["default"])(_this.$content) : null,
        targetRect: targetRect,
        scrollRect: getScrollContainer !== null ? (0, _getBoundingClientRect["default"])(getScrollContainer()) : null,
        align: align,
        offset: _this.props.offset,
        edge: edge
      });
      var tipCoords = {
        x: null,
        y: null,
        rotate: null
      };

      if (_this.$tip) {
        tipCoords = (0, _getPosition.getTipCoordinates)({
          tipRect: (0, _getBoundingClientRect["default"])(_this.$tip),
          targetRect: targetRect,
          contentRect: (0, _getBoundingClientRect["default"])(_this.$content),
          contentCoords: contentCoords,
          align: align
        });
      }

      return {
        tip: tipCoords,
        content: contentCoords
      };
    };

    _this.handleReposition = (0, _lodash["default"])(function () {
      if (_this.isOpen()) {
        var scrollContainer = _this.props.getScrollContainer === null ? document.body : _this.props.getScrollContainer();

        if (!(0, _isInsideBoundaries["default"])({
          $container: scrollContainer,
          $element: _this.$popover.current,
          align: _this.props.align
        })) {
          _this.close();

          return;
        }

        _this.setVisibilityAndPosition();
      }
    }, throttleDelay);

    _this.handleKeyUp = function (event) {
      if (event.key === "Escape") {
        _this.close();

        if (_this.$trigger) _this.$trigger.focus();
      }
    };

    _this.handleKeyDown = function (event) {
      if (event.key === "Tab" && _this.isOpen() && _this.$trigger) {
        var isFocusOnFirst = _this.focusIsOnCertainElementInPopover("first") || document.activeElement === _this.$content;

        var isFocusOnLast = _this.focusIsOnCertainElementInPopover("last");

        if (event.shiftKey && isFocusOnFirst) {
          event.preventDefault();

          _this.focusableElements[_this.triggerFocusIndex].focus();
        } else if (!event.shiftKey && isFocusOnLast) {
          event.preventDefault();

          _this.focusableElements[_this.triggerFocusIndex + 1].focus();
        }
      }
    };

    _this.focusIsOnCertainElementInPopover = function (which) {
      var focusableElementsInPopover = _this.$content.querySelectorAll(focusableElementSelector);

      var index = which === "first" ? 0 : focusableElementsInPopover.length - 1;
      return document.activeElement === focusableElementsInPopover[index];
    };

    _this.elementIsDescendentOfPopover = function (elem) {
      var elementsParent = elem.parentNode;

      while (elementsParent !== null) {
        if (elementsParent.getAttribute && elementsParent.getAttribute("data-pka-anchor") === "popover.content") {
          return true;
        }

        elementsParent = elementsParent.parentNode;
      }

      return false;
    };

    _this.getPopoverTriggerFocusIndex = function () {
      _this.focusableElements.forEach(function (focusableElement, index) {
        if (focusableElement === _this.$trigger) {
          _this.triggerFocusIndex = index;
        }
      });
    };

    _this.handleTransitionEnd = function (event) {
      // NOTE: do this should make more that only focus the content div? should as well
      //       find the first focusable element like button, input, etc?
      //       can focus automatically
      if (!_this.props.shouldKeepFocus && !_this.props.isEager && _this.isOpen() && event.propertyName === "visibility") {
        _this.getPopoverTriggerFocusIndex();

        event.target.focus();
      }
    };

    _this.handleOpen = function () {
      _this.open();
    };

    _this.handleClose = function () {
      _this.close();
    };

    _this.handleDelayedOpen = function () {
      clearTimeout(_this.closeTimer);
      _this.openTimer = setTimeout(_this.handleOpen, openDelay);
    };

    _this.handleDelayedClose = function () {
      clearTimeout(_this.openTimer);
      _this.closeTimer = setTimeout(_this.handleClose, closeDelay);
    };

    _this.handleClick = function () {
      if (_this.isOpen() && !_this.props.shouldKeepFocus && !_this.props.isEager) _this.close();else _this.open();
    };

    _this.refTip = function (ref) {
      _this.$tip = ref;
    };

    _this.refContent = function (ref) {
      _this.$content = ref;
    };

    _this.handleChildChange = function () {
      setTimeout(function () {
        _this.setVisibilityAndPosition();
      });
    };

    _this.hasListeners = false;
    _this.$popover = /*#__PURE__*/_react["default"].createRef();
    _this.$trigger = null;
    _this.$tip = null; // this ref comes from a callback of the <Tip /> component

    if (props.isPortal) {
      var portalNode = document.createElement("div");
      _this.$portal = document.body.appendChild(portalNode);
    }

    _this.focusableElements = [];
    _this.triggerFocusIndex = null;
    _this.state = {
      isOpen: _this.props.defaultIsOpen || false,
      tip: {
        x: 0,
        y: 0
      },
      content: {
        x: 0,
        y: 0
      },
      width: "auto"
    }; // NOTE: should we created a link explaining more deeply this kind of errors?
    //       this type of validation should live in the constructor or somewhere else?

    if (props.isOpen !== null && props.defaultIsOpen !== null) {
      console.error("The use of defaultIsOpen prop is for uncontrolled components only and cannot be used when\n        isOpen prop is also provided.");
    }

    _this.ariaIdForContent = "popover-content_".concat((0, _uuid.v4)());
    return _this;
  }

  (0, _createClass2["default"])(Popover, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // about setState for Popovers and Tooltips in ComponentDidMount
      // https://reactjs.org/docs/react-component.html#componentdidmount
      if (this.isOpen()) {
        this.addListeners();
        this.setVisibilityAndPosition();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.isOpen && this.props.isOpen) {
        this.open();
      }

      if (this.isOpen() && !this.hasListeners) {
        this.focusableElements = document.querySelectorAll(focusableElementSelector);
        this.addListeners();
      }

      if (this.isOpen() && prevProps !== this.props) this.setVisibilityAndPosition();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeListeners();
      clearTimeout(this.openTimer);
      this.openTimer = null;
      clearTimeout(this.closeTimer);
      this.closeTimer = null;

      if (this.props.isPortal) {
        document.body.removeChild(this.$portal);
      }
    }
  }, {
    key: "getContentWidth",
    value: function getContentWidth() {
      var $shadowContent = this.$content.cloneNode(true);
      $shadowContent.style.visibility = "hidden";
      $shadowContent.style.top = 0;
      $shadowContent.style.left = 0;
      $shadowContent.style.width = "auto";
      $shadowContent.style.maxWidth = this.props.maxWidth;
      $shadowContent.style.minWidth = this.props.minWidth;
      document.body.appendChild($shadowContent);
      var contentWidth = (0, _getBoundingClientRect["default"])($shadowContent).width;
      document.body.removeChild($shadowContent);
      return contentWidth;
    }
  }, {
    key: "setVisibilityAndPosition",
    value: function setVisibilityAndPosition() {
      var _this2 = this;

      var isOpening = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.$content) {
        // dynamically setting a fixed width before positioning avoids issues at the
        // right edge of the screen
        if (isOpening && [types.TOP, types.BOTTOM].includes(this.props.align)) {
          var newWidth = this.getContentWidth();

          if (newWidth !== this.state.width) {
            this.setState({
              width: newWidth
            }, function () {
              _this2.updateVisibilityAndPositionState(isOpening);
            });
            return;
          }
        }

        this.updateVisibilityAndPositionState(isOpening);
      }
    }
  }, {
    key: "open",
    value: function open() {
      this.$trigger = document.activeElement;
      this.setVisibilityAndPosition(true);
    }
  }, {
    key: "close",
    value: function close() {
      // NOTE: Even if uncontrolled, the app may want to be notified when closed via the onClose callback
      if (this.props.onClose !== null) {
        this.props.onClose();
      }

      if (this.props.isOpen === null) {
        this.setState({
          isOpen: false
        });
        this.removeListeners();
      }
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      this.focusableElements = document.querySelectorAll(focusableElementSelector);
      return this.props.isOpen !== null ? this.props.isOpen : this.state.isOpen;
    }
  }, {
    key: "updateVisibilityAndPositionState",
    value: function updateVisibilityAndPositionState() {
      var isOpening = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var _this$getCoordinates = this.getCoordinates(),
          content = _this$getCoordinates.content,
          tip = _this$getCoordinates.tip;

      var newState = {
        content: content,
        tip: tip
      };
      if (isOpening) newState.isOpen = true;
      this.setState(newState);
    }
  }, {
    key: "addListeners",
    value: function addListeners() {
      if (this.$content) {
        document.addEventListener("keyup", this.handleKeyUp, false);
        document.addEventListener("keydown", this.handleKeyDown, false);
        document.addEventListener("resize", this.handleReposition, false);
        document.addEventListener("scroll", this.handleReposition, false);

        if (this.props.getScrollContainer !== null) {
          this.props.getScrollContainer().addEventListener("scroll", this.handleReposition, false);
        }

        this.$content.addEventListener("transitionend", this.handleTransitionEnd, false);
        this.hasListeners = true;
      }
    }
  }, {
    key: "removeListeners",
    value: function removeListeners() {
      if (this.$content) {
        document.removeEventListener("resize", this.handleReposition);

        if (this.props.getScrollContainer === null) {
          document.removeEventListener("scroll", this.handleReposition);
        } else {
          this.props.getScrollContainer().removeEventListener("scroll", this.handleReposition);
        }

        document.removeEventListener("keyup", this.handleKeyUp);
        document.removeEventListener("keydown", this.handleKeyDown);
        this.$content.removeEventListener("transitionend", this.handleTransitionEnd);
        this.hasListeners = false;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          align = _this$props2.align,
          children = _this$props2.children,
          isDark = _this$props2.isDark,
          isEager = _this$props2.isEager,
          isOpen = _this$props2.isOpen,
          isPortal = _this$props2.isPortal,
          defaultIsOpen = _this$props2.defaultIsOpen,
          maxWidth = _this$props2.maxWidth,
          minWidth = _this$props2.minWidth,
          onClose = _this$props2.onClose,
          offset = _this$props2.offset,
          getPositioningElement = _this$props2.getPositioningElement,
          getScrollContainer = _this$props2.getScrollContainer,
          zIndex = _this$props2.zIndex,
          moreProps = (0, _objectWithoutProperties2["default"])(_this$props2, ["align", "children", "isDark", "isEager", "isOpen", "isPortal", "defaultIsOpen", "maxWidth", "minWidth", "onClose", "offset", "getPositioningElement", "getScrollContainer", "zIndex"]);
      var contextValue = this.getContextValues(this.state.content, maxWidth, minWidth, this.state.width, isEager, this.isOpen(), isPortal, this.$portal, this.refContent, this.refTip, this.props.shouldKeepFocus, this.state.tip, zIndex, this.ariaIdForContent);
      return /*#__PURE__*/_react["default"].createElement(_PopoverContext.ThemeContext.Provider, {
        value: isDark
      }, /*#__PURE__*/_react["default"].createElement(_PopoverContext["default"].Provider, {
        value: contextValue
      }, /*#__PURE__*/_react["default"].createElement(sc.Popover, (0, _extends2["default"])({
        "data-pka-anchor": "popover"
      }, moreProps, {
        ref: this.$popover
      }), /*#__PURE__*/_react["default"].createElement(PopoverChildren, {
        onChildChange: this.handleChildChange
      }, this.props.children))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (!prevState.isOpen && nextProps.isOpen) {
        return {
          isOpen: true
        };
      }

      return null;
    }
  }]);
  return Popover;
}(_react["default"].Component); // Todo Refactor this when we convert popover component to use hooks


function PopoverChildren(props) {
  var children = props.children,
      onChildChange = props.onChildChange;

  _react["default"].useLayoutEffect(function () {
    if (children) onChildChange();
  }, [children, onChildChange]);

  return children;
}

Popover.types = {
  align: constants.align
};
var propTypes = {
  /** Where the popover content is positioned relative to the trigger or getPositioningElement. */
  align: _propTypes["default"].oneOf([Popover.types.align.TOP, Popover.types.align.RIGHT, Popover.types.align.BOTTOM, Popover.types.align.LEFT]),

  /** Content of the popover */
  children: _propTypes["default"].node.isRequired,

  /** Displays as a "tooltip" style with white text on black background. */
  isDark: _propTypes["default"].bool,

  /** Activated by mouseOver / focus instead of onClick. */
  isEager: _propTypes["default"].bool,

  /** How "controlled" popovers are shown / hidden. */
  isOpen: _propTypes["default"].bool,

  /** This renders the popover inline in the DOM and not in a react portal. WARNING: will have side effects with paprika side panels and modals, use with caution. */
  isPortal: _propTypes["default"].bool,

  /** How "uncontrolled" popovers can be rendered open by default. */
  defaultIsOpen: _propTypes["default"].bool,

  /** Where the edge of the popover content is based on the trigger or getPositioningElement */
  edge: _propTypes["default"].oneOf([Popover.types.align.LEFT, Popover.types.align.RIGHT, null]),

  /** Maximum width of popover content. Using a number is recommended and implies px units. */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /** Minimumn width of popover content. Using a number is recommended and implies px units. */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /** Callback to fire when user closes popover. */
  onClose: _propTypes["default"].func,

  /** Distance, in px, between popover content edge and trigger / getPositioningElement. */
  offset: _propTypes["default"].number,

  /** Function that provides DOM element to use as target for positioning the popover. */
  getPositioningElement: _propTypes["default"].func,

  /** Function that provides the scrolling DOM element that contains the popover. */
  getScrollContainer: _propTypes["default"].func,

  /** If focus will stay at the trigger when showing popover. Popover can still be closed when clicking outside or pressing escape key. */
  shouldKeepFocus: _propTypes["default"].bool,

  /** Number setting the z-index for the popover content / tip. */
  zIndex: _propTypes["default"].number
};
var defaultProps = {
  align: Popover.types.align.BOTTOM,
  isDark: false,
  isEager: false,
  isOpen: null,
  isPortal: true,
  defaultIsOpen: null,
  edge: null,
  maxWidth: 320,
  minWidth: 0,
  onClose: null,
  offset: (0, _parseInt2["default"])(_tokens["default"].spaceLg, 10),
  getPositioningElement: null,
  getScrollContainer: null,
  shouldKeepFocus: false,
  zIndex: (0, _helpers.zValue)(1)
};
Popover.displayName = "Popover";
Popover.propTypes = propTypes;
Popover.defaultProps = defaultProps;
Popover.Trigger = _Trigger["default"];
Popover.Content = _Content["default"];
Popover.Card = _Card["default"];
Popover.Tip = _Tip["default"];
var _default = Popover;
exports["default"] = _default;
//# sourceMappingURL=Popover.js.map